import { type Dispatch, type FC, type SetStateAction } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button, Notification } from 'base-ui'

import { type OpenableControls } from '../../../generic-hooks'

export const DirectContactFormSuccessNotification: FC<{
  handleSuccessClose?: () => void
  modalControls: OpenableControls
  setOnSuccessSubmit: Dispatch<SetStateAction<boolean>>
}> = ({ handleSuccessClose, modalControls, setOnSuccessSubmit }) => {
  return (
    <>
      <Notification
        className="container my-8 mt-0 w-full"
        data-qa-id="productConsultationMessageSuccess"
        severity="success"
      >
        <p className="font-medium text-dark-success">
          <FormattedMessage id="direct.contact.form.submit.success.sub.header" />
        </p>
        <FormattedMessage id="direct.contact.form.submit.success.notification.text" />
      </Notification>
      <Button
        className="mt-auto w-full"
        color="primary"
        onClick={() => {
          setOnSuccessSubmit(false)
          modalControls.handleClose()
          if (handleSuccessClose) {
            handleSuccessClose()
          }
        }}
        size="large"
        variant="filled"
      >
        <FormattedMessage id="general.link.label.close" />
      </Button>
    </>
  )
}
